module.exports = __webpack_public_path__ + "static/media/no-search-data.7bfddfe9.svg";